<template>
    <div class="relative form-dropdown-wrapper">
        <div class="form-dropdown flex justify-between cursor-pointer items-center p-3 rounded-md border border-transparent"
             :class="contrast ? '!border-light-gray border-opacity-50 transition-colors hover:bg-light-gray hover:bg-opacity-50' : 'bg-light-gray bg-opacity-50'"
             @click="toggle">
            <span>
                {{ value.length && !isOpen ? valueLabel : label }}
            </span>
            <icon name="chevron-down"
                  class="relative top-px w-3 h-3 flex-shrink-0 transition-transform transform origin-center fill-current ml-1.5"
                  :class="{'rotate-180': isOpen}"
            />
        </div>
        <label :for="name" class="block w-0 h-0 pointer-events-none">
            <span class="block h-0 w-0 overflow-hidden">{{ label }}</span>
            <input class="opacity-0 transform -translate-y-full"
                   type="text"
                   :id="name"
                   :name="name"
                   :required="required"
                   :value="value"/>
        </label>
        <div v-show="isOpen"
             @click="toggle"
             class="absolute top-full z-30 min-w-max w-full bg-white overflow-hidden rounded-md border border-light-gray mt-1.5">
            <ul class="overflow-y-auto overflow-x-hidden p-3 max-h-96">
                <li v-for="item in items"
                    :key="item.value"
                    @click.stop="select(item)"
                    :class="{
                        'dropdown-item--active' : item.value == value,
                        'text-red hover:bg-light-gray' : item.value == value && contrast,
                        'text-gray hover:text-black' : contrast
                     }"
                    class="dropdown-item cursor-pointer">
                    <div>{{ item.label }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Icon from '../base/Icon.vue';

@Component({
    components: { Icon }
})
export default class FormDropdown extends Vue {
    @Prop({ required: true }) items: { label: string; value: string }[];
    @Prop({ required: true }) name: string;
    @Prop({ required: true }) label: string;
    @Prop({ default: false }) required: boolean;
    @Prop({ default: false, type: Boolean }) primary: boolean;
    @Prop({ default: false, type: Boolean }) allowDeselect: boolean;
    @Prop({ default: false, type: Boolean }) contrast: boolean;

    options: HTMLInputElement[] = [];
    value = '';
    valueLabel = '';
    isOpen = false;

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    }

    destroyed() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    onChange() {
        this.isOpen = true;
    }

    select(result) {
        if (this.allowDeselect && this.value === result.value) {
            this.value = '';
            this.valueLabel = '';
        } else {
            this.value = result.value;
            this.valueLabel = result.label;
        }
        this.isOpen = false;
        this.$emit('selected');
    }

    toggle() {
        this.isOpen = !this.isOpen;
    }

    handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
            this.isOpen = false;
        }
    }
}
</script>
